import { useState } from 'react';
import {
    Document,
    Page,
    View,
    Text,
    Image,
    StyleSheet,
} from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { Button, Modal } from 'antd';
import {
    grayText, paragraph1, paragraph3, paragraph4, paragraph5, paragraph6, paragraph7,
    grayText2, vignette1, vignette2, vignette3, vignette4,
    requiredText, requiredText2, requiredText3, requiredText4, requiredText5, requiredText6,
    vignette5, vignette6, vignette7, vignette8, vignette9, vignette10,
    vignette11, vignette12, vignette13, vignette14, vignette15, vignette16
} from './conscent-emt-texts';
import { IMAGE_API, myHospitals } from '../../../resources';

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 11,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    titleHeader: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050ff',
    },
    date: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050ff',
    },
    grayBox: {
        backgroundColor: '#e0e0e0',
        padding: 10,
        marginBottom: 12,
        borderRadius: 8,
    },
    grayText: {
        fontSize: 12,
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.4,
    },
    paragraphBold: {
        fontWeight: 700,
        marginBottom: 10,
        lineHeight: 1.4,
    },
    paragraph: {
        marginBottom: 10,
        lineHeight: 1.4,
    },
    lineText: {
        marginBottom: 10,
        lineHeight: 1.4,
    },
    bullet: {
        marginLeft: 12,
        marginBottom: 6,
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 32,
        right: 32,
        fontSize: 9,
        textAlign: 'center',
    },
});

export function EmtConsentPage1({ pacienteData }) {
    return (
        <Page size="LETTER" style={styles.page}>
            <View style={styles.header}>
                <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                <View style={styles.headerRight}>
                    <Text style={styles.titleHeader}>R-CDL-058 Consentimiento EMT</Text>
                    <Text style={styles.date}>Ed 01</Text>
                </View>
            </View>

            <View style={styles.grayBox}>
                <Text style={styles.grayText}>{grayText}</Text>
            </View>

            <Text style={styles.paragraphBold}>{paragraph1}</Text>

            <Text style={styles.lineText}>
                El subscrito (paciente) {pacienteData.name} o familiar responsable
                {' '}{pacienteData.responsable?.nombre || '__________________________________________'} del paciente con número de expediente
                {' '}{pacienteData.no_expediente || '_____________________'} del servicio de
                {' '}{pacienteData.service || '______________________.'}.
            </Text>

            <Text style={styles.paragraph}>{paragraph3}</Text>
            <Text style={styles.paragraph}>{paragraph4}</Text>
            <Text style={styles.paragraph}>{paragraph5}</Text>
            <Text style={styles.paragraph}>{paragraph6}</Text>
            <Text style={styles.paragraph}>{paragraph7}</Text>

            <Text style={styles.lineText}>
                Morelia, Michoacán, a ________ de ___________________ del ___________.
            </Text>

            <View style={{ marginTop: 20 }}>
                <Text style={styles.lineText}>PACIENTE O RESPONSABLE DEL PACIENTE</Text>
                <Text style={styles.lineText}>NOMBRE Y FIRMA</Text>
            </View>

            <View style={{ marginTop: 10 }}>
                <Text style={styles.lineText}>MÉDICO TRATANTE</Text>
                <Text style={styles.lineText}>NOMBRE, FIRMA Y CEDULA PROFESIONAL</Text>
            </View>

            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
                <View>
                    <Text style={styles.lineText}>TESTIGO 1</Text>
                    <Text style={styles.lineText}>NOMBRE Y FIRMA</Text>
                </View>
                <View>
                    <Text style={styles.lineText}>TESTIGO 2</Text>
                    <Text style={styles.lineText}>NOMBRE Y FIRMA</Text>
                </View>
            </View>

            <Text style={styles.footer}>
                Este documento es propiedad de CIDERALT y no puede ser distribuido sin autorización de los socios
            </Text>
        </Page>
    );
}

export function EmtConsentPage2() {
    return (
        <Page size="LETTER" style={styles.page}>
            <View style={styles.header}>
                <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                <View style={styles.headerRight}>
                    <Text style={styles.titleHeader}>R-CDL-058 Consentimiento EMT</Text>
                    <Text style={styles.date}>Ed 01</Text>
                </View>
            </View>

            <View style={styles.grayBox}>
                <Text style={styles.grayText}>{grayText2}</Text>
            </View>

            <Text style={styles.paragraph}>{vignette1}</Text>
            <Text style={styles.paragraph}>{vignette2}</Text>
            <Text style={styles.paragraph}>{vignette3}</Text>
            <Text style={styles.paragraph}>{vignette4}</Text>

            <View>
                <Text style={styles.bullet}>• {requiredText}</Text>
                <Text style={styles.bullet}>• {requiredText2}</Text>
                <Text style={styles.bullet}>• {requiredText3}</Text>
                <Text style={styles.bullet}>• {requiredText4}</Text>
                <Text style={styles.bullet}>• {requiredText5}</Text>
                <Text style={styles.bullet}>• {requiredText6}</Text>
            </View>

            <View style={{ marginTop: 14 }}>
                <Text style={styles.paragraph}>{vignette5}</Text>
                <Text style={styles.bullet}>• {vignette6}</Text>
                <Text style={styles.bullet}>• {vignette7}</Text>
                <Text style={styles.bullet}>• {vignette8}</Text>
                <Text style={styles.bullet}>• {vignette9}</Text>
                <Text style={styles.bullet}>• {vignette10}</Text>
                <Text style={styles.bullet}>• {vignette11}</Text>
                <Text style={styles.bullet}>• {vignette12}</Text>
                <Text style={styles.bullet}>• {vignette13}</Text>
                <Text style={styles.bullet}>• {vignette14}</Text>
                <Text style={styles.bullet}>• {vignette15}</Text>
                <Text style={styles.bullet}>• {vignette16}</Text>
                <Text style={{ marginTop: 10, textAlign: 'center' }}>"FIN DEL DOCUMENTO"</Text>
            </View>

            <Text style={styles.footer}>
                Este documento es propiedad de CIDERALT y no puede ser distribuido sin autorización de los socios
            </Text>
        </Page>
    );
}

export default function ConsentimientoEMTPDF({ pacienteData, fechaLabel }) {
    return (
        <Document>
            <EmtConsentPage1 pacienteData={pacienteData} />
            <EmtConsentPage2 />
        </Document>
    );
}

export function ConscentEMTModalDocument({ pacienteData, buttonText = "Ver Expediente PDF" }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <Button onClick={() => setIsOpen(true)}>{buttonText}</Button>
            <Modal open={isOpen} onCancel={() => setIsOpen(false)} width={1000}>
                <PDFViewer style={{ width: '100%', height: '90vh' }}>
                    <ConsentimientoEMTPDF pacienteData={pacienteData} fechaLabel={new Date().toLocaleDateString()} />
                </PDFViewer>
            </Modal>
        </div>
    );
}
